<!-- Seção de Anexos (não-imagens) -->
<div class="flex flex-wrap gap-2 mb-4">
  @for (doc of nonImageDocuments(); track doc.id) {
    <div
      class="attachment-info cursor-pointer transition-colors transition-duration-200"
      (click)="downloadAttachment(doc)"
      [title]="getFileNameFromUrl(doc.link_file)">
      <i class="pi pi-paperclip"></i>
      <div class="flex flex-column">
        <span class="attachment-name">{{ getFileNameFromUrl(doc.link_file) }}</span>
      </div>
      @if (canPreviewAttachment(doc)) {
        <p-button
          icon="pi pi-eye"
          severity="secondary"
          [text]="true"
          size="small"
          pTooltip="Visualizar arquivo"
          tooltipPosition="top"
          styleClass="w-2rem h-2rem p-0 ml-1 flex-shrink-0"
          (onClick)="openFilePreview(doc, $event)" />
      }
      <p-button
        icon="pi pi-link"
        severity="secondary"
        [text]="true"
        size="small"
        pTooltip="Copiar link do anexo"
        tooltipPosition="top"
        styleClass="w-2rem h-2rem p-0 ml-1 flex-shrink-0"
        (onClick)="copyAttachmentLink(doc, $event)" />
      @if (canDeleteAttachment(doc)) {
        <p-button
          icon="pi pi-trash"
          severity="danger"
          [text]="true"
          size="small"
          pTooltip="Remover anexo"
          tooltipPosition="top"
          styleClass="w-2rem h-2rem p-0 ml-1 flex-shrink-0"
          (onClick)="confirmDeleteAttachment(doc, $event)" />
      }
    </div>
  }
  @if (nonImageDocuments().length === 0 && imageDocuments().length === 0) {
    <span class="text-500 text-sm">Nenhum anexo.</span>
  }
</div>

<!-- Seção de Imagens -->
@if (imageDocuments().length > 0) {
  <div class="attachment-images-section">
    <div class="flex flex-wrap gap-2">
      @for (doc of imageDocuments(); track doc.id) {
        <div
          class="attachment-image-thumbnail cursor-pointer transition-all transition-duration-200 hover:shadow-lg relative"
          (click)="downloadAttachment(doc)"
          [title]="doc.observation || getFileNameFromUrl(doc.link_file)">
          <img
            [src]="getImageThumbnailUrl(doc)()"
            [alt]="getFileNameFromUrl(doc.link_file)"
            class="thumbnail-img"
            loading="lazy"
            (error)="
              $event.target.src =
                'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2270%22 height=%2270%22%3E%3Crect fill=%22%23f3f4f6%22 width=%2270%22 height=%2270%22/%3E%3Ctext x=%2250%25%22 y=%2250%25%22 text-anchor=%22middle%22 dy=%22.3em%22 font-size=%2214%22 fill=%22%239ca3af%22%3E?%3C/text%3E%3C/svg%3E'
            " />
          <p-button
            icon="pi pi-link"
            severity="secondary"
            size="small"
            pTooltip="Copiar link do anexo"
            tooltipPosition="top"
            styleClass="absolute top-0 left-0 w-2rem h-2rem p-0"
            (onClick)="copyAttachmentLink(doc, $event)" />
          @if (canDeleteAttachment(doc)) {
            <p-button
              icon="pi pi-trash"
              severity="danger"
              size="small"
              pTooltip="Remover anexo"
              tooltipPosition="top"
              styleClass="absolute top-0 right-0 w-2rem h-2rem p-0"
              (onClick)="confirmDeleteAttachment(doc, $event)" />
          }
        </div>
      }
    </div>
  </div>
}

<!-- Lightbox de Preview de Imagem -->
@if (previewVisible()) {
  <div class="ta-lightbox" (click)="closePreview()" role="dialog" aria-modal="true" aria-label="Visualizar imagem">

    <div class="ta-lightbox-title" (click)="$event.stopPropagation()">{{ previewName() }}</div>

    <button class="ta-lightbox-close" (click)="closePreview()" title="Fechar (Esc)">
      <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>

    <div
      class="ta-lightbox-wrap"
      [class.ta-can-pan]="zoomScale() > 1"
      [class.ta-panning]="dragging()"
      (click)="$event.stopPropagation()"
      (mousedown)="onDragStart($event)"
      (wheel)="onWheelZoom($event)"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd()">
      @if (previewLoading()) {
        <div class="ta-lightbox-loading">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
      } @else if (previewUrl()) {
        <img
          [src]="previewUrl()"
          [alt]="previewName()"
          class="ta-lightbox-img"
          [class.ta-dragging]="dragging()"
          [style.transform]="imageTransform()"
          draggable="false"
          (error)="onPreviewImageError()"
        />
      }
    </div>

    <!-- Toolbar -->
    <div class="ta-lightbox-toolbar" (click)="$event.stopPropagation()">

      @if (imageDocuments().length > 1) {
        <button
          class="ta-toolbar-btn"
          [disabled]="!canGoPrev()"
          [style.opacity]="canGoPrev() ? '1' : '0.35'"
          (click)="prevImage()"
          title="Anterior (←)">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 18l-6-6 6-6"/>
          </svg>
          <span>Anterior</span>
        </button>

        <span class="ta-toolbar-counter">{{ currentImageIndex() + 1 }} / {{ imageDocuments().length }}</span>

        <button
          class="ta-toolbar-btn"
          [disabled]="!canGoNext()"
          [style.opacity]="canGoNext() ? '1' : '0.35'"
          (click)="nextImage()"
          title="Próxima (→)">
          <span>Próxima</span>
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 18l6-6-6-6"/>
          </svg>
        </button>

        <div class="ta-toolbar-sep"></div>
      }

      <button class="ta-toolbar-btn" (click)="zoomOut()" title="Diminuir zoom (-)">
        <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35M8 11h6"/>
        </svg>
        <span>Diminuir</span>
      </button>

      <button class="ta-toolbar-btn" (click)="zoomReset()" title="Tamanho original (0)">
        <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/>
        </svg>
        <span>Original</span>
      </button>

      <button class="ta-toolbar-btn" (click)="zoomIn()" title="Ampliar zoom (+)">
        <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35M11 8v6M8 11h6"/>
        </svg>
        <span>Ampliar</span>
      </button>

      @if (!isInternalPreview()) {
        <div class="ta-toolbar-sep"></div>

        <button class="ta-toolbar-btn" (click)="openCurrentInNewTab()" title="Abrir em nova aba">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/>
            <path d="M15 3h6v6"/><path d="M10 14L21 3"/>
          </svg>
          <span>Abrir</span>
        </button>

        <button
          class="ta-toolbar-btn"
          [class.ta-copied]="copyLinkLabel() !== 'Copiar link'"
          (click)="copyCurrentLink()"
          title="Copiar link da imagem">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
            <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
          </svg>
          <span>{{ copyLinkLabel() }}</span>
        </button>
      }

    </div>
  </div>
}

<!-- Confirmação de exclusão -->
<p-dialog
  [visible]="showDeleteAttachmentDialog()"
  (visibleChange)="showDeleteAttachmentDialog.set($event)"
  [modal]="true"
  header="Remover Anexo"
  [closable]="!deletingAttachment()"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '400px' }">
  <p class="m-0">
    Tem certeza que deseja remover o anexo
    <strong>{{ getFileNameFromUrl(attachmentToDelete()?.link_file) }}</strong>?
    Esta ação não pode ser desfeita.
  </p>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button
        label="Cancelar"
        severity="secondary"
        [outlined]="true"
        [disabled]="deletingAttachment()"
        (onClick)="showDeleteAttachmentDialog.set(false)" />
      <p-button
        label="Remover"
        severity="danger"
        [loading]="deletingAttachment()"
        (onClick)="executeDeleteAttachment()" />
    </div>
  </ng-template>
</p-dialog>

<!-- @defer: o modal e o viewer (e, dentro dele, a docx-preview) só entram na página no
     primeiro clique em visualizar; num chunk próprio, não no bundle inicial da tela. -->
@defer (when filePreviewVisible()) {
  <app-file-preview-modal
    [visible]="filePreviewVisible()"
    [source]="filePreviewSource()"
    [previewRouterLink]="filePreviewRouterLink()"
    (visibleChange)="filePreviewVisible.set($event)"
    (download)="onFilePreviewDownload()"
    (copyLink)="onFilePreviewCopyLink()" />
} @placeholder {
  <!-- nada: sem custo enquanto ninguém abre o preview -->
}
